import { createSelector, MemoizedSelector } from '@ngrx/store';

import * as DeliveryNotesDetailsFeature from '../reducers/delivery-notes-details.reducer';
import { DELIVERY_NOTES_DETAILS_FEATURE_KEY } from '../reducers/delivery-notes-details.reducer';
import { DeliveryNotesState, getDeliveryNotesState } from '../reducers';
import { DeliveryNoteDetailsResponse } from '../../model/delivery-notes.model';


export const selectLoading: MemoizedSelector<DeliveryNotesDetailsFeature.DeliveryNotesDetailsState, boolean>
  = createSelector(
  getDeliveryNotesState,
  (state: DeliveryNotesState) => state[DELIVERY_NOTES_DETAILS_FEATURE_KEY].loading
);

export const selectResponse: MemoizedSelector<DeliveryNotesDetailsFeature.DeliveryNotesDetailsState, DeliveryNoteDetailsResponse>
  = createSelector(
  getDeliveryNotesState,
  (state: DeliveryNotesState) => state[DELIVERY_NOTES_DETAILS_FEATURE_KEY].response
);
